import { render, staticRenderFns } from "./NewService.vue?vue&type=template&id=45de1b0c&scoped=true&"
import script from "./NewService.vue?vue&type=script&lang=js&"
export * from "./NewService.vue?vue&type=script&lang=js&"
import style0 from "./NewService.vue?vue&type=style&index=0&id=45de1b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de1b0c",
  null
  
)

export default component.exports